import styled from 'styled-components'
const roxoRiber = '#662d91'

interface CustomTableWrapperProps {
  autoHeight?: boolean
  colorHeader?: string
}

export const CustomTableWrapper = styled.div<CustomTableWrapperProps>`
  height: ${(props) => (props.autoHeight ? `100%` : `400px`)};
  min-height: 400px;
  width: 100%;
  overflow-y: auto;

  .MuiDataGrid-columnHeaders {
    background-color: ${(props) =>
      props.colorHeader ? props.colorHeader : roxoRiber};
  }
`

export const NoDataWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  & img {
    height: 200px;
    width: fit-content;
  }

  & h2 {
    text-align: center;
    color: #adb5bd;
    font-size: 1.2rem;
    font-weight: $font-weight-bold;
  }
`
